export default __webpack_public_path__ + "static/media/mapping-types.2917e73b.png";